const csvTemplate = `order,customer_code,delivery_name,expiration_date,pricelist,customer_po_number,customer_po_date,cash_before_delivery,reference_ean,quantity
1,HCM-6,DELIV 1,20-06-2025,pricelist 2025 - gt,123456789,21-06-2025,yes,DA.SC-ACIGALL1,100
1,HCM-6,DELIV 1,20-06-2025,pricelist 2025 - gt,123456789,21-06-2025,yes,DE.SC-APD12ALL1,150
1,HCM-6,DELIV 1,20-06-2025,pricelist 2025 - gt,123456789,21-06-2025,yes,DE.SC-APPWSAD12ALL1,10
2,HCM1-00006,DELIV 2,20-06-2025,pricelist 2025 - gt,12345000,22-06-2025,no,4719745010293,100
2,HCM1-00006,DELIV 2,20-06-2025,pricelist 2025 - gt,12345000,22-06-2025,no,4719745505119,100
2,HCM1-00006,DELIV 2,20-06-2025,pricelist 2025 - gt,12345000,22-06-2025,no,4719745015885,100`;

export default csvTemplate;
